import React from 'react';
import SalesDetailPage from './SalesDetailPage';
import { HOLDS_COLUMNS, SORT_TYPES, getDefaultVisibleColumns, getDefaultHiddenColumns } from '../constants/holdsColumnsConfig';
import { compactCurrency } from '../utils/reportingUtils';

const HOLDS_CONFIG = {
  pageTitle: 'Holds',
  pageSubtitle: 'Hold activity across your venues.',
  sidebarKey: 'booking_holds',
  defaultPreset: 'year_to_date',
  dateModeOptions: [
    { key: 'order_date', label: 'Created Date' },
    { key: 'event_date', label: 'Event Date' },
  ],

  columns: HOLDS_COLUMNS,
  sortTypes: SORT_TYPES,
  getDefaultVisibleColumns,
  getDefaultHiddenColumns,
  localStorageKey: (teamId) => `reportingBookingHoldColumns_${teamId}`,
  firstColumnId: 'title',

  kpiFromDetailResponse: true,
  salesDataKey: null,
  venueSeriesKey: null,
  detailEndpoint: (teamId) => `/teams/${teamId}/reporting/booking/holds/data.json`,
  detailResponseKey: 'holds',
  exportBasePath: (teamId) => `/teams/${teamId}/reporting/booking/holds/export`,
  salesExportSection: 'holds',
  detailErrorMessage: 'Failed to load holds data.',
  detailTableTitle: 'Holds',
  emptyMessage: 'No holds found.',
  searchPlaceholder: 'Search holds...',
  paginationLabel: 'holds',
  itemLabel: (count) => `hold${count !== 1 ? 's' : ''}`,

  buildKpiCards: (current, prior) => [
    { label: 'Total Holds', value: (current.total_holds || 0).toLocaleString(), current: current.total_holds || 0, prior: prior.total_holds || 0 },
    { label: 'Converted', value: (current.converted || 0).toLocaleString(), current: current.converted || 0, prior: prior.converted || 0 },
    { label: 'Conversion Rate', value: `${current.conversion_rate || 0}%`, current: current.conversion_rate || 0, prior: prior.conversion_rate || 0 },
    { label: 'Unique Artists', value: (current.unique_artists || 0).toLocaleString(), current: current.unique_artists || 0, prior: prior.unique_artists || 0 },
  ],
  kpiGridColumns: 4,

  chartColor: '#6A4C93',
  salesCardIsCurrency: false,
  salesCardTitle: 'Holds',
  buildMetricValue: (d) => (d.total_holds || 0).toLocaleString(),
  buildMetricLabel: (d) => `${(d.converted || 0).toLocaleString()} converted`,
  overTimeKey: 'over_time',
  countLabel: 'holds',

  topCharts: [
    { title: 'Holds by Venue', dataKey: 'top_venues', barDataKey: 'count', nameKey: 'name', barColor: '#6A4C93', isCurrency: false, tooltipLabel: 'Holds' },
  ],

  groupByOptions: [
    { key: 'venue', label: 'Venue' },
    { key: 'hold', label: 'Individual Hold' },
  ],
  groupByDefault: 'hold',
  eventGroupedColumns: [
    { key: 'venue_name', label: 'Venue' },
    { key: 'hold_count', label: 'Holds' },
    { key: 'converted_count', label: 'Converted' },
  ],

  renderEventCell: (key, row, { currencyFormatter: cf }) => {
    switch (key) {
      case 'venue_name': return row.venue_name || '\u2014';
      case 'hold_count': return row.hold_count.toLocaleString();
      case 'converted_count': return row.converted_count.toLocaleString();
      default: return '\u2014';
    }
  },

  renderCellValue: (col, hold, { formatEventDate, formatEventDateTime }) => {
    switch (col.id) {
      case 'title': return hold.title || '\u2014';
      case 'venue_name': return hold.venue_name || '\u2014';
      case 'event_date': return <span className="text-nowrap">{hold.event_date ? formatEventDate(hold.event_date) : '\u2014'}</span>;
      case 'artists': return (hold.artists || []).join(', ') || '\u2014';
      case 'hold_positions': return hold.hold_positions || '\u2014';
      case 'created_at': return <span className="text-nowrap">{formatEventDateTime(hold.created_at)}</span>;
      case 'converted':
        return hold.converted
          ? <span className="badge" style={{ background: 'var(--sl-bg-success-primary, #ecfdf3)', color: 'var(--sl-text-success, #027a48)', fontSize: 12 }}>Yes</span>
          : <span className="badge" style={{ background: 'var(--sl-bg-tertiary, #f2f4f7)', color: 'var(--sl-text-secondary, #344054)', fontSize: 12 }}>No</span>;
      default: return '\u2014';
    }
  },

  filterTitle: 'Filter Holds',
  filterSubtitle: 'Apply filters to narrow hold data.',
};

function ReportingBookingHoldsPage(props) {
  return <SalesDetailPage {...props} config={HOLDS_CONFIG} />;
}

export default ReportingBookingHoldsPage;
